enum ELocalStorageKeys {
  IS_FIRST_ACCESS = "isFirstAccess",
};

export default ELocalStorageKeys;
